<template>
  <div>
    <div v-show="showHello">
      <section>
        <img src="../../../assets/Logotipo_MasterdaWeb-02.svg" class="logo-img-svg" alt="masterdaweb-logo">

        <div class="card">
          <h2>{{$t('login.welcome')}}</h2>
          <p>{{$t('login.description')}}</p>
          <a class="btn btn-lg btn-primary btn-block btn-white" target="_blank" :href="BASE_URL+'/customer/login'">
            <i class="fa-solid fa-user-plus"></i> {{$t('login.login')}}
          </a>
          <a class="btn btn-lg btn-primary btn-block btn-purple" target="_blank"
             :href="BASE_URL+'/customer/register.php'">
            <i class="fa-solid fa-right-to-bracket"></i> {{$t('login.register')}}
          </a>
          <a class="btn btn-lg btn-primary btn-block " @click="setLogin()">
            <i class="fa-solid fa-user-plus"></i> Acesso Direto
          </a>
        </div>

        <span class="text-white">Copyright 2024 © <a :href="BASE_URL">Master da Web</a></span>
      </section>
    </div>

    <div v-show="showLogin">
      <section>
        <img src="../../../assets/Logotipo_MasterdaWeb-02.svg" class="logo-img-svg" alt="masterdaweb-logo">

        <div class="card" style="max-width: 380px;width: 100%">
          <login v-on:updateAuthEvent="authReturn($event)"/>
          <div class="text-center" style="height: 50px;border-top: 1px solid #ccc;margin-top: 25px;padding-top: 15px;">
            {{ $t('login.notRegistered') }} <a href="#" @click="showRegisterModal('open')">{{ $t('login.createAccount') }}</a>
          </div>
        </div>
      </section>
    </div>

    <vuestic-modal
      ref="showRegisterM"
      :large="false"
      :hasFooter="true"
    >
      <div slot="title">{{'register.signup' | translate}}</div>
      <div>
        <Register v-on:updateAuthEvent="authReturn($event)"/>
      </div>
      <div slot="footer">
        <a @click="showRegisterModal('close')">{{ $t('recover.ok') }}</a>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
  import configs from '@/services/configs'
  import Register from '@/components/auth/forms/Register'
  import Login from '@/components/auth/forms/Login'
  import Purchase from "../../order/Purchase";
  import ProductSettings from "../../order/ProductSettings";
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'notlogged',
    components: {
      Register,
      Login
    },
    data() {
      return {
        BASE_URL: configs.BASE_URL,
        showHello: false,
        showLogin: true,
        showRegister: false,
        showRegisterM: false
      }
    },
    methods: {
      showRegisterModal(action) {
        switch (action) {
          case 'open':
            this.$refs.showRegisterM.open()
            break;
          case 'close':
            this.$refs.showRegisterM.cancel()
            break;
          default:
        }
      },
      setHello() {
        this.showHello = true
        this.showLogin = false
        this.showRegister = false
      },

      setLogin() {
        this.showHello = false
        this.showLogin = true
        this.showRegister = false
      },

      setRegister() {
        this.showHello = false
        this.showLogin = false
        this.showRegister = true
      },

      authReturn(data) {
        if (data.result === 'success') {
          localStorage.setItem('token', data.token.accessToken)
          localStorage.setItem('X-refresh-token', data.token.refreshToken)
          localStorage.setItem('region', data.token.region)
          localStorage.setItem('userid', data.userid)

          // Fetch client details
          this.fetchClientDetails()

          this.$router.push('dashboard')
        } else {
          console.log(error)
          this.$router.push('notlogged')
        }
      },

      ...mapActions('client', ['fetchClientDetails']),
    },
    computed: {
      ...mapState('client', ['clientDetails']),
    },
  }
</script>

<style scoped>
  section {
    background: #0d1025;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100vh;
  }

  .logo {
    width: 350px;
    height: 250px;
    font-size: 100px;
    color: #fff;
  }

  h2 {
    margin: 10px;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    padding: 1em;
    border-radius: 15px;
    margin: 10px;
  }

  .widget {
    height: 66vh;
    overflow: auto;
  }

  .btn {
    padding: 20px 68px;
    font-weight: bold;
  }

  .btn-white {
    color: #7643C9;
    background: #fff;
  }

  .btn-white:hover {
    color: #fff;
    background: #420679;
  }

  .btn-purple {
    background: #7643C9;
  }

  .btn-purple:hover {
    background: #420679;
  }

  .text-white, .text-white > a {
    color: #fff;
    margin-top: 20px;
  }

  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #420679 #ffffff;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 16px;
  }

  *::-webkit-scrollbar-track {
    background: #ffffff;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #420679;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/NotLogged/NotLogged.vue